$(function() {
    $('[data-group]').each(function() {
        let $group = $(this);
        let $label = $group.find('[data-label]');
        let $inp = $group.find('[data-inp]');
        let $select = $group.find('[data-inp]');
        let $textarea = $group.find('[data-inp]');

        var checkPlaceholder = function() {
            let val = $inp.val();
            $group.addClass('focused');
            if (val || $inp.is(':focus')) {
            } else {
                $group.removeClass('focused');
            }
        };

        checkPlaceholder();

        $inp.on('keyup focus blur change mousedown mouseup click', function(e) {
            checkPlaceholder();
        });

    });
})
